
/* 
 * Export component file to be used on project
*/

import  PaymentStatus from './PaymentStatus.js';
export default PaymentStatus;